export const AUDIT_LOGS_COLLECTION = 'auditLogs';

export const AUDIT_IGNORE_FIELDS = [
  'createdAt',
  'updatedAt',
  'id',
] as const;

export const AUDIT_SENSITIVE_KEYS = [
  'password',
  'token',
  'secret',
  'apiKey',
  'privateKey',
  'arcaCAE',
  'arcaCertificate',
  'credential',
  'refreshToken',
  'idToken',
] as const;

export const AUDIT_MAX_STRING_LENGTH = 500;
export const AUDIT_MAX_ARRAY_ITEMS = 50;
export const AUDIT_MAX_OBJECT_KEYS = 40;
